import { jsx as _jsx } from "react/jsx-runtime";
import { useThemeData } from '@msrceng/theme';
import { useStatusStyle } from './useStatusGroups';
/**
 * Tag with automatic colors for different vulnerability report status types
 */
export const VulnReportStatusTag = ({ children }) => {
    const { theme } = useThemeData();
    const { semanticColors } = theme || {};
    const selectedStyle = useStatusStyle(children);
    return (_jsx("span", Object.assign({ style: Object.assign({ borderColor: semanticColors.disabledBorder, borderRadius: '2px', display: 'inline-block', padding: '0.25em 0.5em' }, selectedStyle) }, { children: children })));
};
